<template>
  <div>
    <CompanyHeader :img_header="header_image" header="รายงาน POS" link_back="managepos"/>
    <!-- <MenuCompany/> -->
    <Set_record_information/>
  </div>
</template>

<script>
import CompanyHeader from "@/components/admin/manage_pos/partner_store_setting/menu_partner_store/PartnerHeader";
import HeaderImage from "@/assets/process.png";
// import MenuCompany from "@/components/admin/manage_pos/partner_store_setting/menu_partner_store/MenuPartner";
import Set_record_information from "@/components/admin/manage_pos/partner_store_setting/Set_record_information";
export default {
  name: "SetRecordInformation",
  components: {
    Set_record_information,
    CompanyHeader
  },
  data() {
    return {
      header_image: HeaderImage
    }
  }
}
</script>

<style scoped>

</style>
